import { create } from 'zustand';

export type PlanTab = {
  key: string;
  label: string;
  version?: string;
  completed: boolean;
  recommendationStatus?: string;
  recommendationType?: RecommendationType;
  reportStatus?: string;
  recommendationTaskId?: string;
  [key: string]: any; // To allow additional properties from the recommendation
};

export type RecommendationType = 'INVESTMENT_REPORT' | 'PROTECTION_REPORT';

export interface ISelectedPlanStore {
  selectedPlan: PlanTab | null;
  updateSelectedPlan: (plan: PlanTab | null) => void;
  clearSelectedPlan: () => void;
}

export const useSelectedPlanStore = create<ISelectedPlanStore>((set) => ({
  selectedPlan: null,
  updateSelectedPlan: (plan: PlanTab | null) => set(() => ({ selectedPlan: plan })),
  clearSelectedPlan: () => set(() => ({ selectedPlan: null })),
}));
